"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = require("underscore");

var _SampleEventFactoryInterface = _interopRequireDefault(require("crm_ui/utils/sampleData/SampleEventFactoryInterface"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _engagementStatus = require("crm_ui/constants/engagementStatus");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var PORTAL_ID = _hubspot.default.get();

var makeTaskSampleTimelineEvent = (0, _SampleEventFactoryInterface.default)({
  requiredData: {
    eventType: _TimelineConstants.EVENT_ENGAGEMENT,
    itemType: _EngagementTypes.TASK
  },
  eventDefaults: {
    title: '',
    body: '',
    forObjectType: _ObjectTypes.CONTACT,
    status: _engagementStatus.IN_PROGRESS
  },
  build: function build(taskData) {
    var title = taskData.title,
        body = taskData.body,
        forObjectType = taskData.forObjectType,
        status = taskData.status,
        timestamp = taskData.timestamp;
    var eventData = {
      associateCurrentContact: true,
      scheduledTasks: [{
        engagementId: (0, _underscore.uniqueId)(),
        engagementType: _EngagementTypes.TASK,
        portalId: PORTAL_ID,
        taskType: 'REMINDER',
        timestamp: timestamp,
        uuid: _EngagementTypes.TASK + ":" + (0, _underscore.uniqueId)()
      }],
      metadata: {
        subject: title,
        body: body,
        forObjectType: forObjectType,
        status: status
      }
    };
    return eventData;
  }
});
var _default = makeTaskSampleTimelineEvent;
exports.default = _default;
module.exports = exports.default;